// Roles
export var STUDENT = 'student';
export var VISITOR = 'visitor';